'use strict';

/**
 * ContactBox
 *
 * @author Zorica Janjic <zorica.janjic@namics.com>
 */
T.Module.ContactBox = T.createModule({

	_selectors: {
		contentHolder: '[data-js-o-contact-box__holder]',
		countries: '[data-countries]'
	},

	_stateClasses: {
		componentVisible: 'state-isVisible',
		contactVisible: 'state-isVisible'
	},

	_eventNames: {
		// Used in decorator
		countryFilterChange: 'contactboxcountry.change'
	},

	// Lifecycle

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		// Data
		// …

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on('contactbox.open', this.onContactboxOpen.bind(this));

		// Lifecycle callback
		resolve();
	},
	sync: function sync() {},


	// Events

	onContactboxOpen: function onContactboxOpen() {
		this.$ctx.addClass(this._stateClasses.componentVisible);
		this.initLightbox();
	},


	// Methods

	/**
  *  Initializing Magnific Popup Lightbox
  *
  * @returns {undefined} void
  */
	initLightbox: function initLightbox() {
		var $contentHolder = $(this._selectors.contentHolder);

		// Fail if Contact box content holder not found
		if (!$contentHolder.length) {
			return;
		}

		// Fail if jQuery Plugin not available
		if (!$.magnificPopup) {
			return;
		}

		$.magnificPopup.open({
			items: {
				src: $contentHolder,
				type: 'inline'
			},
			mainClass: 'o-contact-box__lightbox',
			alignTop: 'true',
			fixedContentPos: true,
			fixedBgPos: true
		});

		/*
  *	https://github.com/dimsemenov/Magnific-Popup/issues/280
  *	Issue: select2 "dropdown" input field is added directly to the body,
  *	instead of inside current select2 DOM element.
  *	Above makes popup think that it's outside of it.
  *
  *	Fix:
  *	overriding _onFocusIn event handler and adding an additional check
  */
		$.magnificPopup.instance._onFocusIn = function (e) {
			// Do nothing if target element is select2 input
			if ($(e.target).hasClass('select2-search__field')) {
				return true;
			}
			// Else call parent method
			$.magnificPopup.proto._onFocusIn.call(this, e);
		};
	}
});